import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {SnackbarProvider as NotiStackSnackbarProvider} from "notistack";

const useStyles = makeStyles(() => ({
    containerAnchorOriginTopRight: {
        color: "white !important",
        top: "7rem",
        position: "fixed",
    },
}));

export const SnackbarProvider = ({children}) => {
    const classes = useStyles();

    return (
        <NotiStackSnackbarProvider
            maxSnack={3}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            classes={classes}
        >
            {children}
        </NotiStackSnackbarProvider>
    );
};
